import React, {Component} from "react";
import PublicNavBar from "../../layouts/Home/HomeElements/PublicNavBar";
import PublicFooter from "../../layouts/Home/HomeElements/PublicFooter";
import ContentCreator from "../../layouts/Home/ContentCreator";
import styled from "styled-components";

class PublicContentCreator extends Component {
  state = {
    producer: null,
  };

  render = () => {
    return (
        <div id={"inner"} style={{backgroundColor: "rgb(127, 127, 127)"}}>
          <PublicNavBar  contentCreatorView={true} />
            <ContentCreator isPublic={true} contentCreatorId={this.props.match.params.contentCreatorId} contentCreatorAlias={this.props.match.params.contentCreatorAlias} />
          <PublicFooter {...this.props}/>
        </div>
    );
  };
}

export default PublicContentCreator;


const PublicContainer = styled.div`
  position: relative;
  float: left;
  width: 90%;
  margin: 8% 5% 2%;
  border: 1px solid;
  background: white;
  border-radius: 10px;
`